<template>
  <div class="search_row">
    <v-row no-gutters class="date_filter">
      <v-col class="d-flex pr-4" cols="6">
        <button type="button" class="active_date" :class="{ active: value.active === 'today' }" @click="dateSet('today')">오늘</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'thisMonth' }" @click="dateSet('thisMonth')">이번 달</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'beforeQuarter' }" @click="dateSet('beforeQuarter')">전 분기</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'thisQuarter' }" @click="dateSet('thisQuarter')">이번 분기</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'thisYear' }" @click="dateSet('thisYear')">당해년도</button>
        <button type="button" class="active_date" :class="{ active: value.active === 'All' }" @click="dateSet('All')">전체</button>
      </v-col>
      <v-col class="d-flex" cols="6">
        <date-picker v-model="selectedDate.startDate" :max="selectedDate.endDate" @fieldChanged="removeActiveClass"></date-picker>
        <span class="mark">~</span>
        <date-picker v-model="selectedDate.endDate" :min="selectedDate.startDate" @fieldChanged="removeActiveClass"></date-picker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/common/DatePicker';
export default {
  name: 'DateFilter',
  components: {
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          startDate: '',
          endDate: '',
          active: '',
        };
      },
    },
  },
  data: () => {
    return {
      calendarMenu1: false,
      calendarMenu2: false,
      date: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    selectedDate: {
      handler(val) {
        if (val.startDate === '' && val.endDate === '') this.selectedDate.active = 'All';
      },
      deep: true,
    },
  },
  methods: {
    dateSet(period) {
      this.value.active = period;
      const today = new Date();
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      const year = today.getFullYear();
      const monthIndex = today.getMonth();
      const month = months[monthIndex] < 10 ? `0${months[monthIndex]}` : months[monthIndex];
      const date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
      const quarterStartMonths = ['01', '04', '07', '10'];
      const quarterLastMonths = ['03', '06', '09', '12'];
      let quarter = Math.floor((monthIndex + 3) / 3);
      let sDate = '';
      let eDate = '';
      switch (period) {
        case 'today':
          sDate = `${year}-${month}-${date}`;
          eDate = `${year}-${month}-${date}`;
          break;
        case 'thisMonth':
          sDate = `${year}-${month}-01`;
          eDate = `${year}-${month}-${date}`;
          break;
        case 'beforeQuarter':
          if (quarter === 1) {
            sDate = `${year - 1}-10-01`;
            eDate = `${year - 1}-12-31`;
          } else {
            sDate = `${year}-${quarterStartMonths[quarter - 2]}-01`;
            eDate = `${year}-${quarterLastMonths[quarter - 2]}-${new Date(year, parseInt(quarterLastMonths[quarter - 2]), 0).getDate()}`;
          }
          break;
        case 'thisQuarter':
          sDate = `${year}-${quarterStartMonths[quarter - 1]}-01`;
          eDate = `${year}-${month}-${date}`;
          break;
        case 'thisYear':
          sDate = `${year}-01-01`;
          eDate = `${year}-${month}-${date}`;
          break;
        case 'All':
          sDate = '';
          eDate = '';
          break;
      }
      this.selectedDate.startDate = sDate;
      this.selectedDate.endDate = eDate;
    },
    removeActiveClass() {
      this.value.active = '';
    },
  },
};
</script>

<style scoped></style>
